import moment from "moment-timezone";

export const CHECKLIST_ITEMS = [
  { key: "roasterData", title: "Roster Data" },
  { key: "Directory", title: "Directory" },
  { key: "Program", title: "Program" },
  { key: "pictures", title: "Pictures" },
];

const ROLE_LABELS = {
  ADMIN: "Admin",
  "SUPER-ADMIN": "Super Admin",
  "RETREAT SUB-ADMIN": "Retreat Sub-Admin",
  "COMMITTEE MEMBER": "Committee Member",
  SYSTEM: "Automatic (system)",
  COUPLE: "Couple",
  SUBADMIN: "Sub-Admin",
};

export const isFlagOn = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export const parseConfirmationList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }
  return [];
};

export const getChecklistEntry = (retreatOrList, key) => {
  const confirmation = Array.isArray(retreatOrList)
    ? retreatOrList
    : parseConfirmationList(retreatOrList?.confirmation);
  return confirmation.find(
    (item) => item && Object.prototype.hasOwnProperty.call(item, key),
  );
};

export const confirmationFlag = (retreat, key) => {
  if (isFlagOn(retreat?.confirmedByAdmin) && key !== "retreatStatus") {
    return true;
  }
  const entry = getChecklistEntry(retreat, key);
  return isFlagOn(entry?.[key]);
};

export const formatConfirmRole = (role) => {
  if (!role) return "";
  return ROLE_LABELS[role] || role;
};

export const formatConfirmDate = (value) => {
  if (!value) return "";
  const ny = moment.tz(value, "YYYY-MM-DD HH:mm:ss", "America/New_York");
  if (ny.isValid()) return ny.format("MMM D, YYYY h:mm A");
  const fallback = moment(value);
  return fallback.isValid() ? fallback.format("MMM D, YYYY h:mm A") : value;
};

export const isSystemActor = (name, role, source) =>
  role === "SYSTEM" ||
  source === "system" ||
  name === "Automatic (system)" ||
  name === "SYSTEM AUTO-CONFIRM";
